import React, { useState } from 'react';

/** Imagem com carregamento preguiçoso e entrada suave (evita "pulos" na tela). */
const SmoothImage = ({ className = '', eager = false, alt = '', ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <img
            alt={alt}
            loading={eager ? 'eager' : 'lazy'}
            decoding="async"
            onLoad={() => setLoaded(true)}
            className={`fade-img${loaded ? ' is-loaded' : ''}${className ? ` ${className}` : ''}`}
            {...rest}
        />
    );
};

export default SmoothImage;
